import "./DocumentPublic.mcss";

import { BuxDocumentCliffy } from "@bux/document/cliffy.mts";

new BuxDocumentCliffy();
